import { get } from 'lodash';

const styles = (theme) => ({
  paper: {
    backgroundColor: get(theme, 'color.uiBackground'),
  },
  title: {
    color: get(theme, 'color.bodyText'),
    fontSize: get(theme, 'fontSize.title'),
    fontFamily: get(theme, 'typography.bodyText'),
    fontWeight: 'bold',
  },
  cancelButton: {
    textTransform: 'none',
    color: get(theme, 'color.primaryButtonBackground'),
    backgroundColor: get(theme, 'color.primaryButtonText'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
    marginLeft: 20,
  },
  saveButton: {
    textTransform: 'none',
    color: get(theme, 'color.primaryButtonText'),
    backgroundColor: get(theme, 'color.primaryButtonBackground'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
  },
  additionalButton: {
    textTransform: 'none',
    color: get(theme, 'color.primaryButtonBackground'),
  },
  actionsBtnContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
});

export default styles;
